import { PATH_ROUTES } from 'routes/path';

export type Feature =
  | 'FACE_SCAN'
  | 'VOICE_SCAN'
  | 'AI_REPORT'
  | 'LAB_REPORT'
  | 'SYMPTOM_CHECKER'
  | 'RISK_CHECKER';

const isEnabled = (value?: string) => value !== 'false';

export const FEATURE_FLAGS: Record<Feature, boolean> = {
  FACE_SCAN: isEnabled(process.env.REACT_APP_FEATURE_FACE_SCAN),
  VOICE_SCAN: isEnabled(process.env.REACT_APP_FEATURE_VOICE_SCAN),
  AI_REPORT: isEnabled(process.env.REACT_APP_FEATURE_AI_REPORT),
  LAB_REPORT: isEnabled(process.env.REACT_APP_FEATURE_LAB_REPORT),
  SYMPTOM_CHECKER: isEnabled(process.env.REACT_APP_FEATURE_SYMPTOM_CHECKER),
  RISK_CHECKER: isEnabled(process.env.REACT_APP_FEATURE_RISK_CHECKER),
};

export const isFeatureEnabled = (feature: Feature) => FEATURE_FLAGS[feature];

export const FEATURE_PATHS: Record<Feature, string[]> = {
  FACE_SCAN: [
    PATH_ROUTES.FACE_SCAN,
    PATH_ROUTES.START_FACE_SCAN,
    PATH_ROUTES.FACE_SCAN_RESULT,
    PATH_ROUTES.MOBILE_QR_SCAN,
  ],
  VOICE_SCAN: [
    PATH_ROUTES.VOICE_SCAN,
    PATH_ROUTES.START_VOICE_SCAN,
    PATH_ROUTES.VOICE_SCAN_DETAIL,
  ],
  AI_REPORT: [
    PATH_ROUTES.PERSONALISED_AI_REPORT,
    PATH_ROUTES.GENERATE_AI_REPORT,
  ],
  LAB_REPORT: [
    PATH_ROUTES.INTERPRET_LAB_REPORT,
    PATH_ROUTES.GENERATE_LAB_REPORT,
  ],
  SYMPTOM_CHECKER: [
    PATH_ROUTES.SYMPTOM_CHECKER,
    PATH_ROUTES.GENERATE_SYMPTOM_CHECKER,
    PATH_ROUTES.GENERATE_SYMPTOM_REVIEW,
    PATH_ROUTES.GENERATE_SYMPTOM_GENERATING,
  ],
  RISK_CHECKER: [
    PATH_ROUTES.RISK_ANALYSIS,
    PATH_ROUTES.RISK_ANALYSIS_SCAN,
    PATH_ROUTES.RISK_ANALYSIS_DETAIL,
    PATH_ROUTES.RISK_ANALYSIS_QUESTIONNAIRE,
  ],
};

export const DISABLED_PATHS: string[] = (
  Object.keys(FEATURE_PATHS) as Feature[]
)
  .filter((feature) => !isFeatureEnabled(feature))
  .flatMap((feature) => FEATURE_PATHS[feature]);
